import { Form } from "antd";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { LoadingOutlined, RightOutlined } from "@ant-design/icons";
import { isMobile } from "react-device-detect";
import { saveQuincyPlan, generateScheduleQuincyByLoggedUser } from "shared/service/StrmService";
import ReleaseScheduleQuincy from "../release-schedule-quincy/ReleaseScheduleQuincy";
import { removeMarkdown } from "shared/helpers/string-helper";
import logger from "shared/service/LoggerService";
import "./new-releases-schedule-only-quincy.scss";


const FIELD_CURRENT = "aICurrentPlan";
const FIELD_SUGGESTED = "aISuggestedPlan";

const NewReleasesScheduleOnlyQuincy = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  const generateContent = async () => {
    let response = "";
    try {
      setLoading(true);
      const res: any = await generateScheduleQuincyByLoggedUser();
      response = removeMarkdown(
        res?.response?.schedulePlan ?? "",
      );
    } catch (err) {
      logger.error(err);
    } finally {
      setLoading(false);
      return response;
    }
  }

  const onSave = async () => {
    try {
      await form.validateFields([FIELD_CURRENT]);
      setSaving(true);
      const values = form.getFieldsValue();
      await saveQuincyPlan({
        aICurrentPlan: values[FIELD_CURRENT] ?? "",
        aISuggestedPlan: values[FIELD_SUGGESTED] ?? "",
      });
      toast.success<string>(t("pages.ReleasesSchedule.salvoSucesso"));
      history.push("/releases-schedules");
    } catch (err) {
      logger.error(err);
      toast.error<string>(t("pages.ReleasesSchedule.erroAoSalvar"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className={`container-releases-schedule-only-quincy ${isMobile ? "mobile" : ""}`}
    >
      <div className="content">
        <div className="header-page">
          <p className="title">
            {t("pages.ReleasesSchedule.onlyQuincy.title")}
          </p>
          <p className="subtitle">
            {t("pages.ReleasesSchedule.onlyQuincy.subtitle")}
          </p>
        </div>
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            [FIELD_CURRENT]: "",
            [FIELD_SUGGESTED]: "",
          }}
        >
          <ReleaseScheduleQuincy
            generateContent={generateContent}
            fieldName={FIELD_CURRENT}
            fieldNameSuggested={FIELD_SUGGESTED}
            required={true}
            isVisible={true}
          />
          <div className="footer-actions">
            <button
              type="button"
              className="botao-roxo"
              onClick={onSave}
              disabled={saving || loading}
            >
              {(saving || loading) && <LoadingOutlined />}
              {t("pages.ReleasesSchedule.onlyQuincy.salvar")}
              <RightOutlined />
            </button>
            <button
              type="button"
              className="botao-branco-vazado"
              onClick={() => history.push("/releases-schedules")}
              disabled={saving}
            >
              {t("pages.ReleasesSchedule.voltar")}
            </button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default NewReleasesScheduleOnlyQuincy;
